import { ErrorStateMatcher } from '@angular/material/core';

import { FormControl } from '@angular/forms';

/**
 * @source: https://stackoverflow.com/a/51606362/4049371
 */
export class RepeatPasswordEStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl<string> | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent!.dirty);
    const invalidParent = !!(
      control &&
      control.parent &&
      control.parent.invalid &&
      control.parent.dirty
    );

    return control!.touched && (invalidCtrl || invalidParent);
  }
}
